import axios from 'axios';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { catchRequest } from '.';
import { Toast } from './generateMixin';

const doAxiosRequest = (url, method, token, dispatch, params = {}, setLoading = false, { active = false, text = 'Realizado con éxito', type = 'toast', title = 'Éxito', icon = 'success' } = {}, trigger = false) => new Promise((resolve, reject) => {
    if (setLoading)setLoading(true);
    axios({
        method,
        url,
        data: params,
        headers: { Authorization: token },
    }).then(({ data }) => {
        _.has(data, 'refreshToken') && dispatch({ type: 'ADD_TOKEN', item: { token: data.refreshToken } });
        if (setLoading)setLoading(false);
        if (data.ok) {
            if (trigger) {
                dispatch({
                    type: 'TRIGGER_ACTION',
                    item: trigger,
                });
            }
            if (setLoading) setLoading(false);
            if (active && type === 'toast') {
                Toast.fire({ icon, title, text });
            } else if (active) {
                Swal.fire({ icon, title, text });
            }
        } else if (data.message) {
            Swal.fire({
                icon: 'warning',
                title: 'Ha ocurrido un error',
                text: data.message,
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: '¡Error!',
                text: 'Ocurrió un error al procesar la solicitud',
            });
        }
        resolve(data);
    }).catch((e) => {
        reject(e);
        if (setLoading) setLoading(false);
        catchRequest(e, dispatch);
    });
});
export default doAxiosRequest;
